import {
  CREATE_RESOURCE_DEPENDENCY,
  CREATE_RESOURCE_DEPENDENCIES,
  DELETE_RESOURCE_DEPENDENCY,
  DELETE_RESOURCE_DEPENDENCIES,
  UPDATE_RESOURCE_DEPENDENCY,
  SYNC_FLOW_INTEGRATION_DEPENDENCIES
} from "redux/constants/portal";

export const createResourceDependency = (payload) => ({
  type: CREATE_RESOURCE_DEPENDENCY,
  payload
});

export const createResourceDependencies = (payload) => ({
  type: CREATE_RESOURCE_DEPENDENCIES,
  payload
});

export const deleteResourceDependency = (payload) => ({
  type: DELETE_RESOURCE_DEPENDENCY,
  payload
});

export const deleteResourceDependencies = (payload) => ({
  type: DELETE_RESOURCE_DEPENDENCIES,
  payload
});

export const updateResourceDependency = (payload) => ({
  type: UPDATE_RESOURCE_DEPENDENCY,
  payload
});

export const syncFlowIntegrationDependencies = (payload) => ({
  type: SYNC_FLOW_INTEGRATION_DEPENDENCIES,
  payload
});
